<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.filter"
      @keydown.esc="dialog.filter = false"
      @keydown.enter="dialog.filter = false; dialog.fullscreen = false; fetch();"
      :fullscreen="dialog.fullscreen"
      width="550"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Filter Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.filter = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <!-- <v-col
                cols="12"
                md="6">
                <div>
                  <p class="body-2 mb-2">
                    Bulan
                  </p>

                  <v-select
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    :item-color="set_color"
                    placeholder="Contoh. Januari"
                    :items="months"
                    clearable
                    @click:clear="filter.month = ''"
                    v-model="filter.month"
                    style="border-radius: 10px !important;">
                  </v-select>
                </div>
              </v-col> -->

              <v-col
                cols="12"
                md="6">
                <div>
                  <p class="body-2 mb-2">
                    Tahun
                  </p>

                  <v-select
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    :item-color="set_color"
                    placeholder="Pilih Tahun"
                    :items="years"
                    clearable
                    @click:clear="filter.year = ''"
                    v-model="filter.year"
                    style="border-radius: 10px !important;">
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <div>
              <p class="body-2 mt-4 mb-2">
                Unit
              </p>

              <v-select
                filled
                rounded
                dense
                single-line
                hide-details
                :color="set_color"
                :item-color="set_color"
                placeholder="Contoh. Kantor Pusat SDM"
                :items="unit"
                clearable
                @click:clear="filter.unit = ''"
                v-model="filter.unit"
                class="mb-4"
                style="width: 70%; border-radius: 10px !important;">
              </v-select>
            </div>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.filter = false; dialog.fullscreen = false; fetch();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.reset"
      @keydown.esc="dialog.reset = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Reset Nilai

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin mereset nilai data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.reset"
            :loading="process.reset"
            @click="resetes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Reset
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.reset"
            @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.add_nilai"
      @keydown.esc="dialog.add_nilai = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <div
          class="title font-weight-bold black--text text-center px-4 mt-4 mb-2">
          Pengembangan Ekonomi PT UMB
        </div>

        <div
          class="body-2 text-center mb-4">
          Tentukan nilai berdasarkan informasi dibawah ini:
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>
        
        <v-card-text
          class="pb-1 mt-2">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div
                class="body-2 mb-6">
                <ul
                  style="position: relative; left: -10px;">
                  <li
                    v-for="(item, index) in info"
                    :key="index"
                    :class="index < info.length - 1 ? 'mb-2' : ''"
                    v-html="item">  
                  </li>
                </ul>
              </div>

              <ValidationProvider 
                name="label_score" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- <span class="red--text">*</span> -->
                  Masukan Jumlah Partisipasi (Rp)
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-currency-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :min="0"

                  placeholder="Contoh. 1.000.000"

                  @focus="$event.target.select()"

                  v-model="form.label_score"
                  :success="form.label_score !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Masukan Jumlah Partisipasi (Rp) {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.label_score !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-currency-field>
              </ValidationProvider>

              <ValidationProvider 
                name="score" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- <span class="red--text">*</span> -->
                  Skor
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  readonly

                  placeholder="Contoh. 80"

                  v-model="form.score"
                  :success="form.score !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Skor {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.score !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="addNilai()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.add_nilai = false; dialog.fullscreen = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0; border-radius: 0px 0px 5px 5px;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn
                    elevation="0"
                    dark
                    style="border-radius: 10px;"
                    :color="set_color"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="dialog.filter = true; fetchUnit();">
                    <v-icon size="18">mdi-filter-outline</v-icon>

                    <span class="ml-1">
                      Filter
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3" v-if="selected.row.length === 1 && selected.row[0].indicator_score === ''">
                  <v-btn 
                    @click="dialog.add_nilai = true; reset();"
                    elevation="0"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text">
                    <v-icon size="18">mdi-check-circle-outline</v-icon>

                    <span class="ml-1">
                      Nilai Sekarang
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3" v-if="selected.row.length === 1 && selected.row[0].indicator_score !== ''">
                  <v-btn
                    @click="toReset()"
                    elevation="0"
                    style="background: #ff980033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center orange--text">
                    <v-icon size="18">mdi-reload</v-icon>

                    <span class="ml-1">
                      Reset Nilai
                    </span>
                  </v-btn>
                </div>
                
                <div class="mr-3" v-if="selected.row.length === 1">
                  <v-btn
                    :to="`/evaluation/officer/aik/pengembangan/${selected.row[0].user_id}`"
                    elevation="0"
                    style="background: #e0e0e0; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                      Detail
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="set_color"
                        elevation="0"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        style="border-radius: 10px;"
                        :disabled="process.print"
                        :loading="process.print"
                        @click="prints()"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>
                      Print
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- FREEZE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div>

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>

            <div
              class="body-2 my-2">
              <!-- Periode nilai bulan <strong class="black--text">{{ filter.month | convert_month }}</strong> tahun <strong class="black--text">{{ filter.year }}</strong> -->
              Periode nilai tahun <strong class="black--text">{{ filter.year }}</strong>
            </div>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '358px' : '286px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value, index }">
              <div
                v-bind:key="header.value">
                <div v-if="header.format !== 'link' && header.format !== 'percent'">
                  {{ rowFormat(header.format, value) }} 
                </div>

                <div v-if="header.format === 'link'"
                  @click="toLink(index)"
                  class="cursor-pointer">
                  <span
                    :class="value === '' ? 'primary--text' : 'grey--text'">
                    {{ value === '' ? 'Belum Dinilai' : 'Sudah Dinilai' }}
                  </span>
                </div>
                
                <div v-if="header.format === 'percent'">
                 {{ value }}{{ value !== '' ? '%' : '' }}
                </div>
              </div>
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          add_nilai: false,
          reset: false
        },
        search: '',
        filter: {
          month: '01',
          year: new Date().getFullYear(),
          unit: ''
        },
        selected: {
          row: [],
          freeze: [],
          reset: []
        },

        info: [
          'Kurang dari 1.000.000 (Skor 20)',
          'Lebih dari sama dengan 1.000.000 sampai kurang dari 1.500.000 (Skor 40)',
          'Lebih dari sama dengan 1.500.000 sampai kurang dari 2.000.000 (Skor 60)',
          'Lebih dari sama dengan 2.000.000 sampai kurang dari 2.500.000 (Skor 80)',
          'Lebih dari sama dengan 2.500.000 (Skor 100)'
        ],

        unit: [],

        detail: {},

        options: {},
        headers: [],
        list: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,

        form: {
          user_id: '',
          label_score: '',
          score: '',

          indicator_id: ''
        },

        process: {
          load: false,
          form: false,
          print: false,
          reset: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb < 10 ? `0${numb}` : `${numb}`

        return [
          {
            text: 'Januari',
            value: '01'
          },
          {
            text: 'Februari',
            value: '02'
          },
          {
            text: 'Maret',
            value: '03'
          },
          {
            text: 'April',
            value: '04'
          },
          {
            text: 'Mei',
            value: '05'
          },
          {
            text: 'Juni',
            value: '06'
          },
          {
            text: 'Juli',
            value: '07'
          },
          {
            text: 'Agustus',
            value: '08'
          },
          {
            text: 'September',
            value: '09'
          },
          {
            text: 'Oktober',
            value: '10'
          },
          {
            text: 'November',
            value: '11'
          },
          {
            text: 'Desember',
            value: '12'
          }
        ]
      },
      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },

      'form.label_score': function(val) {
        if (val === '') {
          this.form.score = ''
        } else {
          if  (val < 1) {
            this.form.score = 0
          }
          
          if (val > 0 && val < 1000000) {
            this.form.score = 20
          }
  
          if (val >= 1000000 && val < 1500000) {
            this.form.score = 40
          }
  
          if (val >= 1500000 && val < 2000000) {
            this.form.score = 60
          }
  
          if (val >= 2000000 && val < 2500000) {
            this.form.score = 80
          }
  
          if (val >= 2500000) {
            this.form.score = 100
          }
        }
      }
    },
    mounted () {
      // this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'link') {
          data = value
        } else if (format === 'percent') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,

          unit_id: this.filter.unit,
          // month: this.filter.month,
          year: this.filter.year,

          // indicator_id: this.$route.query.indicator !== undefined ? this.$route.query.indicator : 8
        }

        this.selected.row = []

        await get('kpi/pengembangan_ekonomi/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nomor Induk Pegawai',
                width: '200px',
                value: 'user_code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Lengkap',
                width: '400px',
                value: 'user_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Unit',
                width: '250px',
                value: 'unit_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Jumlah Partisipasi (Rp)',
                width: '200px',
                value: 'indicator_label_score',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              },
              {
                text: 'Skor',
                width: '120px',
                value: 'indicator_score',
                freeze: false,
                hide: false,
                align: 'center'
              },
              // {
              //   text: 'Status Penilaian',
              //   width: '200px',
              //   value: 'status',
              //   freeze: false,
              //   hide: false,
              //   format: 'link'
              // },
              // {
              //   text: 'Tanggal Dibuat',
              //   width: '200px',
              //   value: 'indicator_input_datetime',
              //   freeze: false,
              //   hide: false,
              //   format: 'datetime'
              // }
            ]

            this.list = []
            
            let data = res.results.data

            data.map(obj => {
              this.list.push({
                id: obj.id,
                user_id: obj.user_id,
                indicator_id: obj.indicator_id,
                user_code: obj.user_code,
                user_name: obj.user_name,
                user_position: obj.user_position,
                indicator_label_score: obj.indicator_label_score,
                indicator_score: obj.indicator_score,
                indicator_input_datetime: obj.indicator_input_datetime,
                unit_id: obj.unit_id,
                unit_name: obj.unit_name,

                status: obj.indicator_score
              })
            })

            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        // await axios({
        //   url: `${process.env.VUE_APP_API_URL}admin/report/export`,
        //   method: 'GET',
        //   responseType: 'blob', // important,
        //   // params: params,
        //   headers: {
        //     Authorization: process.env.VUE_APP_XAUTH,
        //     token: TokenService.getToken()
        //   }
        // }).then((response) => {
        //   let res = response

        //   if (res.status === 200) {
        //     this.process.print = false
            
        //     this.dialog.snackbar = true
        //     this.message.success = 'Berhasil mengeksport excel'

        //     const url = window.URL.createObjectURL(new Blob([response.data]))
        //     const link = document.createElement('a')
        //     link.href = url
        //     link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
        //     document.body.appendChild(link)
        //     link.click()
        //   } else {
        //     this.process.print = false
        //     this.message.error = res.message
        //   }
        // })
      },

      // UNIT
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.unit = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.unit.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },

      toLink (index) {
        // this.list[index].id
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        let params = {
          unit_id: this.filter.unit,
          // month: this.filter.month,
          year: this.filter.year,

          user_id: this.selected.row[0].user_id
        }

        get('kpi/pengembangan_ekonomi/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form = {
              user_id: this.selected.row[0].user_id,
              label_score: res.results.label !== undefined ? parseInt(res.results.label) : '',
              score: res.results.score !== undefined ? res.results.score : '',

              // indicator_id: this.$route.query.indicator !== undefined ? this.$route.query.indicator : 8
            }
          }
        })

        this.process.form = false

        this.message.error = ''
      },

      async addNilai () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('kpi/pengembangan_ekonomi/add_score', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.add_nilai = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toReset () {
        this.selected.reset = []

        for (let i in this.selected.row) {
          this.selected.reset.push(parseInt(this.selected.row[i].indicator_id))
        }

        this.dialog.reset = true
      },
      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post('kpi/pengembangan_ekonomi/reset_score', {
          data: {
            id: this.selected.reset[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.reset = false
            this.dialog.reset = false

            this.selected.row = []
            this.selected.reset = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.reset = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>